import logger from 'common/logger';
import {
  TTS_CONTROL_KNOB_ID,
  TTS_CONTROL_KNOB_BG_ID,
  TTS_CONTROL_CHECKBOX_ID,
} from './widgetClassNames';

import { Div, Img, Label, Input, Span, Text } from './utils';

const SpeakingAvatar = ({ align, avatar, onSpeechControlChange, allowed, control }) => {
  const avatarInputValidationMessage = 'avatar input is not valid';
  try {
    const inputIsValid = avatar?.silent?.src?.length && avatar?.speaking?.src?.length;
    if (!inputIsValid) throw new Error(avatarInputValidationMessage);

    const widgetWidth = 365;
    const style = {
      position: 'fixed',
      bottom: '10px',
      right: align === 'right' ? `${widgetWidth}px` : 'unset',
      left: align === 'left' ? `${widgetWidth}px` : 'unset',
    };
    const div = Div({ style });
    const avatarView = Img({
      alt: '',
      src: avatar.silent.src,
      width: 120,
    });

    const knobDiameter = 16;
    const knobBorder = 3;
    const colorWhenChecked = '#66bb6a';
    const colorWhenUnchecked = '#ccc';
    const getBgColorForStatus = checked => (checked ? colorWhenChecked : colorWhenUnchecked);
    const getPositionForStatus = checked =>
      checked ? `translateX(${knobDiameter}px)` : 'translateX(0)';
    const controlView = Label(
      {
        style: {
          display: 'flex',
          width: '100px',
          flex: 'initial',
          'align-items': 'center',
          'justify-content': 'center',
        },
        for: TTS_CONTROL_CHECKBOX_ID,
      },
      [
        Span(
          {
            style: {
              display: 'inline-block',
              margin: '5px 3px',
            },
          },
          Text(control.label)
        ),

        Div(
          {
            style: {
              display: 'inline-block',
              margin: '5px 3px',
              height: `${knobDiameter + 2 * knobBorder}px`,
              position: 'relative',
              width: `${2 * knobDiameter + 2 * knobBorder}px`,
            },
          },
          [
            Input({
              style: {
                display: 'none',
              },
              type: 'checkbox',
              checked: allowed,
              id: TTS_CONTROL_CHECKBOX_ID,
            }),
            Div(
              {
                id: TTS_CONTROL_KNOB_BG_ID,
                style: {
                  'background-color': getBgColorForStatus(allowed),
                  bottom: 0,
                  cursor: 'pointer',
                  left: 0,
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  transition: '.4s',
                  'border-radius': `${knobDiameter + 2 * knobBorder}px`,
                },
              },
              Span(
                {
                  id: TTS_CONTROL_KNOB_ID,
                  style: {
                    'background-color': '#fff',
                    bottom: `${knobBorder}px`,
                    content: '',
                    height: `${knobDiameter}px`,
                    left: `${knobBorder}px`,
                    position: 'absolute',
                    transition: '.4s',
                    width: `${knobDiameter}px`,
                    'border-radius': '50%',
                    transform: getPositionForStatus(allowed),
                  },
                },
                Text('')
              )
            ),
          ]
        ),
      ]
    );

    div.appendChild(avatarView);
    div.appendChild(controlView);
    const onChange = e => {
      if (e.target.type !== 'checkbox') return;

      onSpeechControlChange({
        allowed: e.target.checked,
      });
      document.getElementById(TTS_CONTROL_KNOB_ID).style.transform = getPositionForStatus(
        e.target.checked
      );
      document.getElementById(TTS_CONTROL_KNOB_BG_ID).style.backgroundColor = getBgColorForStatus(
        e.target.checked
      );
    };

    return {
      view: div,
      setSpeaking: isSpeaking => {
        avatarView.src = isSpeaking ? avatar.speaking.src : avatar.silent.src;
      },
      hide: () => {
        div.style.display = 'none';
        controlView.removeEventListener('change', onChange);
      },
      show: () => {
        div.style.display = 'block';
        controlView.addEventListener('change', onChange);
      },
    };
  } catch (error) {
    if (error.message === avatarInputValidationMessage) {
      logger.error(error);
      return null;
    }
    throw error;
  }
};

export default SpeakingAvatar;
